import React, {
  createContext,
  FC,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useHash } from 'clientState/hooks/useUrlParams';

const PerformedSemSearchHashContext = createContext<string | null>(null);

const SemSearchRequestHashProvider: FC = ({ children }) => {
  const hash = useHash();
  const [semHash, setSemHash] = useState(hash);
  useEffect(() => {
    setSemHash(hash);
  }, [hash]);

  return (
    <PerformedSemSearchHashContext.Provider value={semHash}>
      {children}
    </PerformedSemSearchHashContext.Provider>
  );
};

// TODO - We might not need these hooks since we're using the same context
// as results. We could move the provider to the results file
export const usePerformedSemSearchHash = (): string | null =>
  useContext(PerformedSemSearchHashContext);

export default SemSearchRequestHashProvider;
